import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/questionnaire-templates/{questionnaireTemplateId}/pdf-templates']['GET'];
type Input = ThisApi['params'];

const getPdfTemplatesByQuestionnaireId = async ({ questionnaireTemplateId }: Input): Promise<ThisApi['response']> => {
  const data = await formsBackendClient.get(`/questionnaire-templates/${questionnaireTemplateId}/pdf-templates`);
  return data.data;
};

export default getPdfTemplatesByQuestionnaireId;
